"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    MapIcon: ()=>MapIcon,
    SinglePinIcon: ()=>SinglePinIcon
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
require("react");
const index_js_namespaceObject = require("../../constants/index.js");
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
const external_pcln_icons_namespaceObject = require("pcln-icons");
const external_styled_components_namespaceObject = require("styled-components");
var external_styled_components_default = /*#__PURE__*/ __webpack_require__.n(external_styled_components_namespaceObject);
const IconBox = /*#__PURE__*/ external_styled_components_default()(external_pcln_design_system_namespaceObject.Box).withConfig({
    displayName: "SinglePinIcon__IconBox"
})([
    "border-radius:50%;box-shadow:0 -1px 0 0 rgba(0,0,0,0.03),0 0 2px 0 rgba(0,0,0,0.2),0 4px 2px -2px rgba(0,0,0,0.12),0 4px 8px -1px rgba(0,0,0,0.16);width:24px;height:24px;background:linear-gradient( 132.8deg,#7701bb 12.64%,#7601bb 17.94%,#7503bc 23.08%,#7205bd 28.07%,#6e09bf 32.93%,#690dc1 37.69%,#6312c4 42.36%,#5c18c7 46.96%,#541fca 51.52%,#4c27ce 56.05%,#422fd2 60.57%,#3738d7 65.11%,#2c42dc 69.68%,#204de1 74.31%,#1358e7 79.01%,#0564ed 83.8% ),radial-gradient( 90.13% 94.81% at 14.57% 5.35%,rgba(245,235,250,0.7) 0%,rgba(238,222,246,0.605208) 16.15%,rgba(232,210,243,0.514991) 33.33%,rgba(209,168,232,0.203394) 66.15%,rgba(201,153,228,0.0965608) 82.29%,rgba(194,140,224,0) 100% ),radial-gradient( 33.32% 66.63% at 81.46% 89.53%,rgba(232,242,255,0.3) 0%,rgba(232,242,255,0.3) 0.01%,rgba(153,195,249,0) 100% );svg{transform:translate(25%,24%);height:16px;width:16px;}"
]);
const MapIcon = ({ type, iconProp })=>{
    switch(type){
        case index_js_namespaceObject.mapPinType.MUSEUM:
            return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_icons_namespaceObject.Museum, {
                ...iconProp
            });
        case index_js_namespaceObject.mapPinType.BEACH:
            return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_icons_namespaceObject.Beach, {
                ...iconProp
            });
        case index_js_namespaceObject.mapPinType.RESTAURANT:
            return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_icons_namespaceObject.Restaurant, {
                ...iconProp
            });
        case index_js_namespaceObject.mapPinType.HOTEL:
            return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_icons_namespaceObject.KingBed, {
                ...iconProp
            });
        case index_js_namespaceObject.mapPinType.AIRPORT:
            return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_icons_namespaceObject.Departure, {
                ...iconProp
            });
        case index_js_namespaceObject.mapPinType.MOUNTAIN:
            return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_icons_namespaceObject.Mountain, {
                ...iconProp
            });
        case index_js_namespaceObject.mapPinType.PARK:
            return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_icons_namespaceObject.Park, {
                ...iconProp
            });
        case index_js_namespaceObject.mapPinType.ACTIVITY:
            return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_icons_namespaceObject.Activity, {
                ...iconProp
            });
        case index_js_namespaceObject.mapPinType.ATTRACTION:
        case index_js_namespaceObject.mapPinType.POI:
            return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_icons_namespaceObject.Attraction, {
                ...iconProp
            });
        case 'TRANSIT':
            return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_icons_namespaceObject.Train, {
                ...iconProp
            });
        case 'CITY':
        default:
            return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_icons_namespaceObject.Pin, {
                ...iconProp
            });
    }
};
const SinglePinIcon = ({ type })=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(IconBox, {
        bg: "background.lightest",
        "data-testid": "single-pin-icon",
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(MapIcon, {
            type: type,
            iconProp: {
                color: 'text.lightest'
            }
        })
    });
exports.MapIcon = __webpack_exports__.MapIcon;
exports.SinglePinIcon = __webpack_exports__.SinglePinIcon;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "MapIcon",
    "SinglePinIcon"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
